import React, {FC} from "react";
import {
    Box,
    Typography,
} from "@mui/material";
import {
    Info,
    Warning,
} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";

interface InfoMessageProps {
    message?: string;
    messageLocaId?: IdlocaGeneric;
    type: "info" | "warning";
    icon?: JSX.Element;
}

export const InfoMessage: FC<InfoMessageProps> = ({message, messageLocaId, type, icon}) => {
    const infoMessage = messageLocaId ? <Locale localeId={messageLocaId}/> : message;
    const defaultIcon = type === "info" ? <Info sx={{marginRight: "8px"}}/> : <Warning sx={{marginRight: "8px"}}/>;

    // TODO use theme colors

    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            padding: "8px 16px",
            borderRadius: "8px",
            backgroundColor: type === "info" ? "#e3f2fd" : "#fff3e0",
            boxShadow: 1,
            marginBottom: "16px",
        }}>
            {icon || defaultIcon}
            <Typography variant="body2" sx={{color: type === "info" ? "#1976d2" : "#f57c00"}}>
                {infoMessage || "Message not available"}
            </Typography>
        </Box>
    );
};
